<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">平台奖励记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="0" class="title">全部</el-menu-item>
            <el-menu-item index="1" class="title">待系统核算</el-menu-item>
            <el-menu-item index="2" class="title">待结算</el-menu-item>
            <el-menu-item index="3" class="title">已结算</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div>
            <el-dialog
              :title="title"
              :visible.sync="detail"
              width="900px"
              style="text-align: left"
              :close-on-click-modal="false"
              center
            >
              <div class="dialogbox">
                <div class="title">获奖医生信息</div>
                <div class="info">
                  <span>{{ info.doctor_name }}</span>
                  <span>{{ info.doctor_sex == 1 ? "男" : "女" }}</span>
                  <span>{{ info.doctor_title }}</span>
                  <span>{{ info.doctor_phone }}</span>
                </div>
                <div class="title" v-if="info.type != 5">{{ table_title }}</div>
                <div style="padding: 20px" v-if="info.type != 5">
                  <div style="border: 1px solid #ccc">
                    <!-- 邀请患者奖励 -->
                    <el-table
                      :data="user_info"
                      style="width: 100%"
                      v-if="detail_type == 1"
                    >
                      <el-table-column
                        prop="nick_name"
                        label="用户昵称"
                      ></el-table-column>
                      <el-table-column
                        prop="phone"
                        label="手机号"
                      ></el-table-column>
                      <el-table-column
                        prop="real_name"
                        label="患者姓名"
                      ></el-table-column>
                      <el-table-column label="性别">
                        <template slot-scope="scope">
                          <div v-if="scope.row.sex == 1">男</div>
                          <div v-if="scope.row.sex == 2">女</div>
                          <div v-if="scope.row.sex == 0">未知</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="age"
                        label="年龄"
                      ></el-table-column>
                      <el-table-column
                        prop="reg_time"
                        label="注册时间"
                        width="160"
                      ></el-table-column>
                    </el-table>

                    <!-- 首次开单奖励 -->
                    <el-table
                      :data="order_list"
                      style="width: 100%"
                      v-if="detail_type == 2"
                    >
                      <el-table-column
                        prop="order_sn"
                        label="订单编号"
                      ></el-table-column>
                      <el-table-column
                        prop="drug_price"
                        label="药品金额"
                      ></el-table-column>
                      <el-table-column
                        prop="user_name"
                        label="患者姓名"
                      ></el-table-column>
                      <el-table-column
                        prop="completion_time"
                        label="收货时间"
                      ></el-table-column>
                    </el-table>

                    <!-- 邀请医生奖励 -->
                    <el-table
                      :data="register_info"
                      style="width: 100%"
                      v-if="detail_type == 3"
                    >
                      <el-table-column
                        prop="doctor_name"
                        label="医生姓名"
                      ></el-table-column>
                      <el-table-column label="性别">
                        <template slot-scope="scope">
                          <div v-if="scope.row.doctor_sex == 1">男</div>
                          <div v-if="scope.row.doctor_sex == 2">女</div>
                          <div v-if="scope.row.doctor_sex == 0">未知</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="doctor_title"
                        label="职称"
                      ></el-table-column>
                      <el-table-column
                        prop="doctor_phone"
                        label="手机号"
                      ></el-table-column>
                      <el-table-column
                        prop="doctor_auth_time"
                        label="认证时间"
                      ></el-table-column>
                    </el-table>

                    <!-- 商城奖励 -->
                    <el-table
                      :data="commission_info"
                      style="width: 100%"
                      v-if="detail_type == 4"
                    >
                      <el-table-column
                        prop="ordersn"
                        label="订单编号"
                      ></el-table-column>
                      <el-table-column
                        prop="goodsprice"
                        label="商品金额"
                      ></el-table-column>
                      <el-table-column
                        prop="realname"
                        label="买家ID"
                      ></el-table-column>
                      <el-table-column
                        prop="finishtime"
                        label="完成时间"
                      ></el-table-column>
                    </el-table>
                  </div>
                </div>

                <div class="money">
                  <span class="money_title">奖励金额：</span>
                  <span class="money_num">{{ info.money }}</span>
                </div>
              </div>
            </el-dialog>
            <div class="searchbox">
              <div class="item">
                <span>医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_name"
                  style="width: 140px; margin-left: 6px"
                  clearable
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>手机号</span>
                <el-input
                  placeholder="请输入"
                  v-model="phone"
                  style="width: 140px; margin-left: 6px"
                  clearable
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>奖励类型</span>
                <el-select
                  v-model="type"
                  placeholder="请选择"
                  style="width: 160px; margin-left: 6px"
                  @change="search"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span style="margin-right: 10px">是否测试医生</span>
                <el-radio-group v-model="is_test" @change="search">
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-left: 6px;
                  "
                  @click="search"
                  >查询</el-button
                >
                <!-- 导出 -->
                <el-button
                  type="primary"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1768')
                      : false
                  "
                  @click="derive"
                >
                  导出<i class="el-icon-download el-icon--right" />
                </el-button>
              </div>
            </div>

            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column label="医生信息">
                  <template slot-scope="scope">
                    <div
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor: pointer"
                    >
                      {{ scope.row.doctor_name }}
                    </div>
                    <div>
                      <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
                      <span style="margin-left: 10px">{{
                        scope.row.title
                      }}</span>
                    </div>
                    <div>{{ scope.row.phone }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="奖励类型">
                  <template slot-scope="scope">
                    <div>{{ scope.row.type_str }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖励金额"
                  prop="money"
                ></el-table-column>

                <el-table-column label="结算状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.doc_settlement == 1">待系统核算</span>
                    <span v-if="scope.row.doc_settlement == 2">待结算</span>
                    <span v-if="scope.row.doc_settlement == 3">已结算</span>
                    <span v-if="scope.row.doc_settlement == 4">已失效</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="业务时间"
                  prop="reward_time"
                ></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toDetail(scope.row)"
                      >查看详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div style="margin-top: 24px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import doctor_fee from "../../../api/doctor_fee";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      activeIndex: "0",
      active: "0",
      date: [],
      totalNum: 0,
      doctor_name: "",
      phone: "",
      type: "",
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      detail: false,
      detail_type: "",
      //邀请患者
      user_info: [],
      //邀请医生
      register_info: [],
      //开单奖励
      order_list: [],
      //商城奖励
      commission_info: [],
      info: {},
      title: "邀请患者奖",
      table_title: "邀请用户/患者信息",
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "邀请患者奖",
        },
        {
          value: 2,
          label: "首次开单奖",
        },
        {
          value: 3,
          label: "邀请医生奖",
        },
        {
          value: 4,
          label: "商城奖励",
        },
        {
          value: 5,
          label: "平台活动奖励",
        },
        {
          value: 7,
          label: "邀请新用户阶梯奖励",
        },
      ],
      is_test: 2,
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    handleSelect(key) {
      this.active = Number(key);
      this.settlement_status = this.active;
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        settlement_status: this.settlement_status,
        doctor_name: this.doctor_name,
        phone: this.phone,
        type: this.type,
        is_test: this.is_test,
      };
      doctor_fee.getRewardList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.reward_time = platform.timestampToTime(item.reward_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看详情
    toDetail(row) {
      let reward_id = row.reward_id;
      let type = row.type;
      this.detail_type = type;
      // 1邀请患者奖，2首次开单奖，3邀请医生奖,4商城奖励,5平台活动奖励，7新用户阶梯奖
      doctor_fee.getRewardInfo({ reward_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.info = res.data.info;
          if (type == 1) {
            this.user_info = [];
            detail.user_info.reg_time = platform.timestampToTime(
              detail.user_info.reg_time
            );
            this.title = row.type_str;
            this.table_title = "邀请用户/患者信息";
            this.user_info.push(detail.user_info);
          } else if (type == 2) {
            this.order_list = detail.order_list.map((item) => {
              item.completion_time = platform.timestampToTime(
                item.completion_time
              );
              return item;
            });
            this.title = row.type_str;
            this.table_title = "订单信息";
          } else if (type == 3) {
            this.register_info = [];
            detail.register_info.doctor_auth_time = platform.timestampToTime(
              detail.register_info.doctor_auth_time
            );
            this.title = row.type_str;
            this.table_title = "邀请医生信息";
            this.register_info.push(detail.register_info);
          } else if (type == 4) {
            this.commission_info = [];
            detail.commission_info.finishtime = platform.timestampToTime(
              detail.commission_info.finishtime
            );
            this.title = row.type_str;
            this.table_title = "订单信息";
            this.commission_info.push(detail.commission_info);
          } else if (type == 5) {
            // this.user_info = [];
            // detail.user_info.reg_time = platform.timestampToTime(
            //   detail.user_info.reg_time
            // );
            this.title = row.type_str;
            this.table_title = "";
            // this.user_info.push(detail.user_info);
          } else if (type == 7) {
            this.title = row.type_str;
            this.table_title = "";
          }
          setTimeout(() => {
            this.detail = true;
          }, 300);
        }
      });
    },
    // 导出
    derive() {
      const loading = this.$loading();
      let params = {
        settlement_status: this.settlement_status,
        doctor_name: this.doctor_name,
        phone: this.phone,
        type: this.type,
        is_test: this.is_test,
      };
      doctor_fee
        .exportRewardList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 20px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.title {
  font-size: 16px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .item {
    margin-right: 14px;
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
}
.dialogbox {
  text-align: center;
  border: 1px solid #ccc;
  .title {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    background: #e5e5e5;
  }
  .info {
    padding: 0 30px;
    box-sizing: border-box;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.money {
  text-align: right;
  padding-right: 40px;
  height: 40px;
  .money_title {
    font-size: 16px;
    font-weight: 500;
  }
  .money_num {
    font-size: 20px;
    font-weight: 600;
    color: #f24e33;
  }
}
</style>
